module.exports = __webpack_public_path__ + "static/prodinity_main_6-1d0b753c9c6a6aba0a180a10081ec36e.png";